import * as React from "react";
import { BusinessReportOutcome } from "@/modules/snapshots/businessReports.types";
import { CircleCheckBig, TriangleAlert } from "lucide-react";
import { useUpdateBusinessReportOutcomeMutation } from "@/modules/snapshots/businessReports.api";
import TopBarProgress from "react-topbar-progress-indicator";

interface Props {
  businessReportOutcome: BusinessReportOutcome;
}

export const SnapshotCollectionsOutcomesRowVerified: React.FC<Props> = ({ businessReportOutcome }) => {
  const [updateBusinessReportOutcome, { isLoading }] = useUpdateBusinessReportOutcomeMutation();
  const handleClick = () => {
    updateBusinessReportOutcome({ id: businessReportOutcome.id, data: { verified: !businessReportOutcome.verified } });
  };

  return (
    <div onClick={handleClick} className="flex cursor-pointer items-center">
      {isLoading && <TopBarProgress />}
      {businessReportOutcome.verified ? (
        <div className="m-auto text-green-600">
          <CircleCheckBig className="h-4 w-4" />
        </div>
      ) : (
        <div className="m-auto text-yellow-600">
          <TriangleAlert className="h-4 w-4" />
        </div>
      )}
    </div>
  );
};
